
// 商品IDをセッションストレージに保存する関数
function saveRecentlyViewedProduct(productHandle) {
  let recentlyViewedProducts = JSON.parse(sessionStorage.getItem('recentlyViewedProducts')) || [];
  
  // 既に保存されている場合は削除
  const index = recentlyViewedProducts.indexOf(productHandle);
  if (index > -1) {
    recentlyViewedProducts.splice(index, 1);
  }
  
  // 先頭に追加
  recentlyViewedProducts.unshift(productHandle);
  
  // 最大5個まで保存
  if (recentlyViewedProducts.length > 5) {
    recentlyViewedProducts = recentlyViewedProducts.slice(0, 5);
  }
  
  sessionStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProducts));
}

// 最近見た商品を表示する関数
function displayRecentlyViewedProducts() {
  const recentlyViewedProducts = JSON.parse(sessionStorage.getItem('recentlyViewedProducts')) || [];
  console.log("function displayRecentlyViewedProducts() > recentlyViewedProducts: ");
  console.log(recentlyViewedProducts);

  if (recentlyViewedProducts.length === 0) {
    return;
  }

  const productHandles = recentlyViewedProducts.join(',');
  console.log("productHandles: ",productHandles);

  const productPromises = recentlyViewedProducts.map(handle => {
    return fetch(`https://thaifun-shop.com/products/${handle}.json`)
      .then(response => response.json())
      .then(data => data.product);
  });

  Promise.all(productPromises)
    .then(products => {
      
      let html = '<h2 class="h3">最近チェックしたアイテム</h2>';
      html += '<ul class="grid product-grid grid--5-col-desktop grid--2-col-tablet-down">';
      
      products.slice(0, 5).forEach(product => {
        console.log("product");
        console.log( product);
        // 商品の最初の画像のURLを取得
        const imageUrl = product.images && product.images[0] && product.images[0].src ? product.images[0].src : '';
       
        html += `
          <li class="grid__item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media"  style="--ratio-percent: 100%;">
                <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">
                  <div class="card--media">
                    <a href="/products/${product.handle}">
                      <div class="media media--transparent media--hover-effect">
                        ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" width="810" height="776" class="motion-reduce mediasize" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" >` : ''}
                      </div>
                    </a>
                  </div>
                </div>
                <div class="card__content" style="margin-top:1rem;">
                  <h3 class="card__heading h5">
                    <a href="/products/${product.handle}" class="full-unstyled-link">
                      ${product.title}
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </li>
        `;
      });
      
      html += '</ul>';
      
      document.getElementById('recently-viewed-products').innerHTML = html;
    })
}

// 商品ページでのみ実行
if (window.location.pathname.includes('/products/')) {
  let productHandle = window.location.pathname.split('/').pop();
  productHandle = productHandle.split('?')[0]; // クエリパラメータを削除
  console.log("productHandle: " + productHandle);
  saveRecentlyViewedProduct(productHandle);
}
  
  // テストデータを使用して最近見た商品を保存
// const testProductIds = ['message-shoot', 'message-blowkiss', 'message-blowkiss-me', 'message-fox'];
// testProductIds.forEach(productId => {
//   saveRecentlyViewedProduct(productId);
// });

// 全てのページで実行
displayRecentlyViewedProducts();
